(function () {
  class FreeSpinsWildPanel extends PIXI.Container {
    constructor() {
      super();
      const self = this;
      this._completeCallback;
      StateMachine.Create(this);
      Reflex.registerEventHandler('orientationChange', this.onOrientationChange.bind(this));
    }

    initialise() {
      const self = this;
      messageBus.subscribe('spinner:GameConfigEvent', function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this.symbolPanels = [];
      this.wildPanels = [];

      for (let i = 0; i < 5; i++) {
        let symbolPanel = {
          highlight: resourceManager.get(
            'freeSpinsWildPanel:freeSpinsWildPanelContainer:symbolsContainer:symbol' + i + ':symbolHighlight'
          ),
        };
        symbolPanel.highlight.visible = false;
        this.symbolPanels.push(symbolPanel);

        let multiplierMov = resourceManager.createObject(
          'movie',
          'multiplierOverlay',
          'freeSpinsWildPanel:freeSpinsWildPanelContainer:wildsContainer:symbol' + i,
          {
            definition: 'multipliers',
            anchor: 0.5,
            x: 0,
            y: 28,
            scale: 0.57,
            loop: false,
          }
        );
        multiplierMov.visible = false;

        if (i < 4) {
          let wildPanel = {
            dimSymbol: resourceManager.get(
              'freeSpinsWildPanel:freeSpinsWildPanelContainer:wildsContainer:symbol' + i + ':unlitWild'
            ),
            wildSymbol: resourceManager.get(
              'freeSpinsWildPanel:freeSpinsWildPanelContainer:wildsContainer:symbol' + i + ':wildSymbol'
            ),
            multiplier: multiplierMov,
          };
          wildPanel.wildSymbol.visible = false;
          this.wildPanels.push(wildPanel);
        } else {
          this.paysFishMultiplier = resourceManager.get(
            'freeSpinsWildPanel:freeSpinsWildPanelContainer:wildsContainer:symbol' + i + ':payFishMultiplier'
          );
        }
      }
    }

    updateWildMultipliers() {
      if (!gameController.inFreeSpins) {
        return;
      }

      for (let i = 0; i < 4; i++) {
        if (gameController.wildPanelMultipliers[i] == 0) {
          this.wildPanels[i].dimSymbol.visible = true;
          this.wildPanels[i].wildSymbol.visible = false;
          this.wildPanels[i].multiplier.visible = false;
        } else {
          this.wildPanels[i].dimSymbol.visible = false;
          this.wildPanels[i].wildSymbol.visible = true;

          if (gameController.wildPanelMultipliers[i] > 1) {
            this.wildPanels[i].multiplier.gotoAndStop(gameController.wildPanelMultipliers[i] - 2);
            this.wildPanels[i].multiplier.visible = true;
          } else {
            this.wildPanels[i].multiplier.visible = false;
          }
        }
      }

      let fishPaysMulti = gameController.wildPanelMultipliers[4] + 1;
      gameController.currentFishermanMultiplier = fishPaysMulti;
      this.paysFishMultiplier.setTranslationParameters(fishPaysMulti);
    }

    updateWildMultiplierPanel(symbolID, completeCallback) {
      let symIndex = gameController.getWildMultiplierPanelSymIndex(symbolID);
      this.symbolPanels[symIndex].highlight.alpha = 0;
      this.symbolPanels[symIndex].highlight.visible = true;

      gameController.freeSpinsWildTransitions[symIndex].position = helpers.getWildPanelSymbolPos(symIndex);
      gameController.freeSpinsWildTransitions[symIndex].visible = true;
      gameController.freeSpinsWildTransitions[symIndex].gotoAndPlay(0);

      gameController.wildPanelMultipliers[symIndex]++;
      // Jamie - use frame number later
      const self = this;
      timerManager.addTimeout(200, function () {
        self.updateWildMultipliers();
      });

      // Jamie - don't neccesarilly know where to call the callback
      // Won't always be at the end of the animation
      // Will depend on what looks good
      timerManager.addTimeout(1000, function () {
        completeCallback();
      });

      if (symbolID === 9) {
        let sparklePos = helpers.getWildPanelSymbolPos(symIndex);
        gameController.spinSparkle(sparklePos, 0.5, 0.5, function () {});
      }

      gsap.to(this.symbolPanels[symIndex].highlight, {
        duration: 0.5,
        ease: 'sine',
        alpha: 1,
        onComplete: () => {
          gsap.to(this.symbolPanels[symIndex].highlight, {
            duration: 0.5,
            ease: 'sine',
            alpha: 0,
            onComplete: () => {
              this.symbolPanels[symIndex].highlight.visible = false;
            },
          });
        },
      });
    }

    onOrientationChange() {
      this.updateWildMultipliers();
    }
  }

  create = function (json) {
    return new FreeSpinsWildPanel();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType('freeSpinsWildPanel', create, initialise, getFilesRequired);
})();
